module.exports = __webpack_public_path__ + "static/media/a1.ab12fd3.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chenlong/a1.mp3
// module id = rLMr
// module chunks = 0